import Lucide from "@/components/Base/Lucide";

type PageLoadingOverlayProps = {
  show: boolean;
  label?: string;
};

function PageLoadingOverlay({ show, label = "Loading…" }: PageLoadingOverlayProps) {
  if (!show) return null;
  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/25 dark:bg-black/45"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3 rounded-xl bg-white dark:bg-darkmode-700 px-8 py-6 shadow-lg">
        <Lucide icon="Loader2" className="w-10 h-10 animate-spin text-primary" />
        <div className="text-sm text-slate-600 dark:text-slate-300">{label}</div>
      </div>
    </div>
  );
}

export default PageLoadingOverlay;
